var map = {
	"./Cardiology.svg": "SRag",
	"./Dermatology.svg": "SQy7",
	"./Ear, Nose & Throat.svg": "6Qul",
	"./Endocrinology.svg": "V8EM",
	"./Gastroenterology & Hepatology.svg": "vOTy",
	"./Hematology.svg": "x9yG",
	"./Hereditary Cancer.svg": "HCoM",
	"./Immunology.svg": "iva/",
	"./Malformations.svg": "VBfA",
	"./Metabolic and Mitochondrial Disorders.svg": "HZ4l",
	"./NBS.svg": "hVPs",
	"./Nephrology.svg": "FUqK",
	"./Neurology.svg": "M0RH",
	"./Ophthalmology.svg": "K4Tr",
	"./Osteology.svg": "F9Jn",
	"./Others.svg": "XE98",
	"./Pulmonology.svg": "SkAt",
	"./Reproductive.svg": "Mt5Y"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mr+9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/divisionIcons ^\.\/.*\.svg$
// module id = mr+9
// module chunks = 26